<div class="slots">
    <vb-segmented
        [options]="zoneOptions"
        [activeId]="selectedZone"
        ariaLabel="Morning or afternoon"
        (activeChange)="selectZone($event)">
    </vb-segmented>

    <div class="slots__grid" *ngIf="activeSlots.length > 0">
        <button
            type="button"
            *ngFor="let slot of activeSlots"
            class="slots__slot"
            [class.slots__slot--selected]="selectedSlot === slot"
            [disabled]="slot.availableSlots === 0"
            (click)="selectSlot(slot)">
            {{ slot.slotLabel }}
        </button>
    </div>
    <p class="slots__empty" *ngIf="activeSlots.length === 0">
        No available slots for the selected date.
    </p>
</div>
